import logoPic from '../assets/logo.jpg';
const Introduction = () => {
    return ( 
        <div className="introduction">
            <div className="container">
                <div className="box box1">
                    <h2>Hello! My name is Himanshu Dutt</h2>
                    <p>
                        Since childhood, I have been fascinated by technology. 
                        I love to keep myself updated with new tech. 
                        I know some programming languages like C/C++. 
                        I love to design apps, although I am new to them. 
                        My greatest strength is that I am always ready to change 
                        according to a given situation.
                    </p>
                </div>
                <div className="box box2">
                    <img src={logoPic} alt='logo' className="logo-photo" />
                </div>
            </div>

        </div>
     );
}
 
export default Introduction;